import React, { useState } from "react";

export default function LineupSummary(props) {
  const [summaryShow, setSummaryShow] = useState(false);

  function toggleSummaryShow() {
    setSummaryShow(!summaryShow);
  }

  return (
    <div className="gm-lineups-summary">
      <div
        className="gm-lineup-summary-header"
        onClick={toggleSummaryShow}
        onKeyPress={toggleSummaryShow}
        role="button"
        tabIndex={0}
      >
        <div className="gm-lineup-summary-title">{props.summaryTitle}</div>
        <div className="gm-lineup-toggle">
          Click To {summaryShow ? "Collapse" : "Expand"}
        </div>
      </div>

      {summaryShow && props.summaryForLineupSet ? (
        <div className="gm-lineup-summary-players">
          <table className="gm-lineup-summary-table">
            <thead>
              <td>
                <strong>Player</strong>
              </td>
              <td>
                <strong>Target Exposure</strong>
              </td>
              <td>
                <strong>Actual Exposure</strong>
              </td>
              <td>
                <strong>Exposure Diff</strong>
              </td>
            </thead>
            <tbody>
              {JSON.parse(props.summaryForLineupSet.playerSummary).map(
                (player, index) => {
                  return (
                    <tr key={index}>
                      <td>{player[0]}</td>
                      <td>{player[1]}</td>
                      <td>{player[2]}</td>
                      <td>{player[2] - player[1]}</td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
